import styled, {css} from "styled-components";
import {GhostButton, PrimaryButton} from "account/components/AccountCards";
import {fontFamilies, radii} from "theme/tokens";

/*
 * The primitives of this dialog that the account's withdrawal dialog no longer shares since it became
 * "Cancel and get a refund" (kitecorp/transferify-ui#3698) and took a layout of its own. Kept here verbatim,
 * so the sponsor booking's dialog looks exactly as it did; the ones both dialogs still share are in
 * `components/DeclarationDialog.styles`.
 */

export const Body = styled.div`
	padding: 0 24px 24px;
`;

export const TermsText = styled.p`
	margin: 0;
	font-size: 13.5px;
	line-height: 1.6;
	color: ${({theme}) => theme.tokens.ink2};
`;

export const Success = styled.div`
	padding: 8px 24px 24px;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
`;

export const SuccessNote = styled.p`
	margin: 0;
	max-width: 360px;
	font-size: 15px;
	line-height: 1.55;
	color: ${({theme}) => theme.tokens.ink2};
`;

/**
 * Generic read-only key/value list (`<dl>`/`<dt>`/`<dd>`). Shared by the success screen's request
 * reference AND, since ui#1152, the pre-submission account/plan pair that answers art. 11^1 alin. (4)(b)
 * — one visual language for "here is a fact you can't edit, only confirm", not two near-identical styles.
 */
export const DetailList = styled.dl`
	width: 100%;
	max-width: 360px;
	box-sizing: border-box;
	margin: 0;
	padding: 12px 14px;
	border: 1px solid ${({theme}) => theme.tokens.cardBorder};
	border-radius: ${radii.control};
	background: ${({theme}) => theme.tokens.field};
	text-align: left;
`;

export const DetailLabel = styled.dt`
	font-size: 12px;
	font-weight: 700;
	color: ${({theme}) => theme.tokens.ink2};
`;

export const DetailValue = styled.dd`
	margin: 4px 0 0;
	font-family: ${fontFamilies.mono};
	font-size: 13px;
	line-height: 1.45;
	color: ${({theme}) => theme.tokens.ink};
`;

// The booking entry and receipt action sit outside DialogActions, which otherwise supplies this target size.
const touchTarget = css`
	min-height: 44px;
	height: auto;
	max-width: 100%;
	white-space: normal;
	overflow-wrap: anywhere;
`;

export const WithdrawalTrigger = styled(GhostButton)`${touchTarget}`;
export const ReceiptDone = styled(PrimaryButton)`${touchTarget}`;

/** A valid name can be one long word; preserve the recorded line breaks without horizontal scrolling. */
export const RecordedDeclaration = styled(SuccessNote)`
	min-width: 0;
	max-width: 100%;
	overflow-wrap: anywhere;
	white-space: pre-wrap;
`;
